import Avatar from "../../../images/assets/avatar.jpg"
import {useState} from "react";
import classNames from "classnames";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import jwt_decode from "jwt-decode";

const TopbarUserInfoWidget = () => {
    const { token } = useSelector((state) => state.auth);
    const [visiable, setVisible] = useState(false);

    const handleToggle = () => {
        setVisible((current) => !current);
    }

    const dropDownClassNames = {
        'dropdown-list': true,
        'active': visiable
    }

    return (
        <li>
            <div className="v-align-middle">
                <div className="dropdown">
                    <a href="#" onClick={handleToggle}
                       className="nav-icon flex no-page-fade no-label-on-mobile no-margin-bottom no-padding-right">
                        <img width="30" height="30" className="avatar circle pull-left no-margin-bottom hide-on-mobile"
                             src={Avatar} alt="" /><span>{(token && jwt_decode(token.accessToken).sub) ? jwt_decode(token.accessToken).sub : ''}</span><span
                            className="icon-down"></span></a>
                    <div className={classNames(dropDownClassNames)}>
                        <ul>
                            <li>
                                <Link to="/mypage">마이페이지</Link>
                            </li>
                            <li>
                                <Link to="/logout">로그아웃</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </li>
    )
}

export default TopbarUserInfoWidget;